module.exports = __webpack_public_path__ + "img/42.e1aa651b.jpg";